










































































import { defineComponent, ref } from '@vue/composition-api';
import { surveyHeadersData } from '@/bundles/Survey/helpers';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { useTable } from '@/bundles/BaseTable/composables/useTable';
import { ISurveyData } from '@/bundles/Survey/types';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';

export default defineComponent({
  name: 'SurveyListTable',

  components: {
    BaseTable,
  },

  emits: ['options:change'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
  },

  setup: function (props, { emit }) {
    const { calculateHeight } = useTable();
    const answersDialog = ref(false);
    const selectedSurvey = ref<ISurveyData | null>(null);

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    function formatTime(totalTime: number | null): string {
      if (!totalTime) return 'N/A';
      const hours = Math.floor(totalTime / 3600);
      const minutes = Math.floor((totalTime % 3600) / 60);
      const seconds = totalTime % 60;

      if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
      } else {
        return `${seconds}s`;
      }
    }

    function showAnswers(survey: ISurveyData) {
      selectedSurvey.value = survey;
      answersDialog.value = true;
    }

    function closeDialog() {
      answersDialog.value = false;
      selectedSurvey.value = null;
    }

    function formatDate(dateString: string): string {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    }

    return {
      surveyHeadersData,
      calculateHeight,
      optionsChangeEventHandler,
      formatTime,
      formatDate,
      showAnswers,
      closeDialog,
      answersDialog,
      selectedSurvey,
    };
  },
});
